import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import axios from 'axios';

export default function Error(props) {
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [errorDescription, setErrorDescription] = React.useState(null);
    const params = new URLSearchParams(window.location.search);
    const errorId = params.get("errorId");

    React.useEffect(() => {
        const axiosconfig = {
            headers: {
                "Content-Type": "application/json"
            },
        };
        
        axios.get(`/identity/account/error?errorId=${errorId}`, axiosconfig)
            .then(response => {
                setError(response.data.error.replace('_', ' '));
                setErrorDescription(response.data.errorDescription.replace('_', ' '));
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [errorId]);

    return (
        <>
            <Box
                sx={{
                    marginTop: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Alert severity="error" sx={{mt: 2}}>
                    An error occurred while processing your request.

                    <Typography variant="p" gutterBottom component="div" sx={{ mt: 2 }}>
                        <strong>Error: </strong> {loading ? "Loading..." : error !== null ? error : "Unknown error"}
                    </Typography>
                    <Typography variant="p" gutterBottom component="div">
                        <strong>Error Description: </strong> {loading ? "Loading..." : errorDescription !== null ? errorDescription : "Unknown error"}
                    </Typography>
                </Alert>
            </Box>

        </>
    );
}